import { getDfltFilter } from 'helper/utils';
import { build } from 'helper/build';
import {
	FILTER_CONDITION_LABELS,
	MOD_TMPT_LIST,
	STR_ORDER_LIST,
	ORDER_FORECAST_DEFAULT_FILTER as OFDefaultFilters,
	ENTERPRISE_INVENTORY,
	ENTERPRISE_INVENTORY_DEFAULT_FILTER as EIDefaultFilters,
	FUTURE_VALID_LIST,
	TENDER_ANALYSIS_LIST,
	ECOMM_INSTOCK_LIST,
	SHIP_TO_ZIP_LIST,
	PERSONA,
	ATTRIBS_LOWERCASE
} from 'constants/constant';

const handleBuildReport = (
	selectedTemplate,
	templateData,
	userPersona,
	blackOut,
	sbuDBTechNames,
	sbuDepartments,
	selectedView,
	dispatchFilterList,
	dispatchSelectedList
) => {
	let defaultFilterSel = getDfltFilter(templateData);
	const SBUDfltCondition = FILTER_CONDITION_LABELS.IS_EQUAL_TO;
	let preSelectedList = [];
	if (userPersona === PERSONA.MERCHANT && !blackOut) {
		const SBUdimension = templateData[0].dimensions.filter((dim) =>
			sbuDBTechNames.includes(dim.dbtechnicalName)
		);

		const dfltFiltersOnDimensions = [];
		SBUdimension.map((dim) => {
			dfltFiltersOnDimensions.push({
				dimension: dim,
				condition: SBUDfltCondition,
				value: sbuDepartments.map((dept) => dept.deptNum)
			});
		});
		defaultFilterSel = getDfltFilter(templateData, dfltFiltersOnDimensions);

		defaultFilterSel.map((filter, index) => {
			if (sbuDBTechNames.includes(filter.dbtechnicalName)) {
				const field = build(defaultFilterSel[index], selectedView, userPersona);
				defaultFilterSel[index] = { ...defaultFilterSel[index], field };
			}
		});
	}

	// TODO: need to refactor after Mid May release
	if (MOD_TMPT_LIST.includes(Number(selectedTemplate))) {
		const technicalName = 'store_item_valid_ind';
		const SBUdimension = templateData[0].dimensions.filter((dim) =>
			sbuDBTechNames.includes(dim.dbtechnicalName)
		);
		const dimensionToBeFiltered = templateData[0]?.dimensions.find(
			(dim) => dim.technicalName === technicalName
		);
		// Add the default filter
		const defaultFiltersOnDimensions = [
			{
				dimension: dimensionToBeFiltered,
				condition: SBUDfltCondition,
				value: ['1']
			}
		];
		// Modular plan metrics for a Merchant with certain SBUs assigned - if the user selects Omni department number as a filter,
		// Omni department number should be a required filter with pre-selected SBUs
		SBUdimension.map((dim) => {
			defaultFiltersOnDimensions.push({
				dimension: dim,
				condition: SBUDfltCondition,
				value: sbuDepartments.map((dept) => dept.deptNum)
			});
		});

		defaultFilterSel = getDfltFilter(templateData, defaultFiltersOnDimensions);

		const index = defaultFilterSel.findIndex((filter) => filter.technicalName === technicalName);
		if (index >= 0) {
			const field = build(defaultFilterSel[index], selectedView, userPersona);
			defaultFilterSel[index] = { ...defaultFilterSel[index], field };
		}

		preSelectedList.push({ ...dimensionToBeFiltered, parent: ATTRIBS_LOWERCASE.dimensions });
	}

	if (ENTERPRISE_INVENTORY.includes(Number(selectedTemplate))) {
		const dimensionToBeFiltered = templateData[0]?.dimensions.find((dim) =>
			EIDefaultFilters.includes(dim.technicalName)
		);
		// Add the default filter
		const defaultFiltersOnDimensions = [
			{
				dimension: dimensionToBeFiltered,
				condition: SBUDfltCondition,
				value: ['1']
			}
		];
		defaultFilterSel = getDfltFilter(templateData, defaultFiltersOnDimensions);
		const index = defaultFilterSel.findIndex((filter) =>
			EIDefaultFilters.includes(filter.technicalName)
		);
		if (index >= 0) {
			const field = build(defaultFilterSel[index], selectedView, userPersona);
			defaultFilterSel[index] = { ...defaultFilterSel[index], field };
		}

		preSelectedList.push({ ...dimensionToBeFiltered, parent: ATTRIBS_LOWERCASE.dimensions });
	}

	// Order Forecast enhancement, pre-select 'DC/Store Number' and 'DC/Store Type'
	if (STR_ORDER_LIST.includes(Number(selectedTemplate))) {
		templateData[0].dimensions.forEach((dimension) => {
			if (OFDefaultFilters.includes(dimension.businessName)) {
				preSelectedList.push({ ...dimension, parent: ATTRIBS_LOWERCASE.dimensions });
			}
		});
	}

	if (FUTURE_VALID_LIST.includes(Number(selectedTemplate))) {
		templateData[0].dimensions.forEach((dimension) => {
			if (OFDefaultFilters.includes(dimension.businessName)) {
				preSelectedList.push({ ...dimension, parent: ATTRIBS_LOWERCASE.dimensions });
			}
		});
	}

	if ([...ECOMM_INSTOCK_LIST].includes(Number(selectedTemplate))) {
		defaultFilterSel = getDfltFilter(templateData, undefined, false);
	}

	if ([...TENDER_ANALYSIS_LIST, ...SHIP_TO_ZIP_LIST].includes(Number(selectedTemplate))) {
		defaultFilterSel = getDfltFilter(templateData, undefined, true);
	}

	dispatchFilterList(defaultFilterSel);
	dispatchSelectedList(preSelectedList);
};

export { handleBuildReport };
